module.exports = __webpack_public_path__ + "assets/pluseSignBig-9b3e68.svg";